import type { Payload } from "./model";
import { PLACEMENTS, chinaDisplay, publicUrl, creativeUrl } from "./model";
export function CreativePreview({ payload }: { payload: Payload }) {
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap justify-between gap-2">
        <div>
          <h3 className="font-semibold">{payload.title || "未命名广告"}</h3>
          <p className="text-xs text-gray-500 mt-1">
            {chinaDisplay(payload.start_at)} 至 {chinaDisplay(payload.end_at)} ·
            中国时间
          </p>
        </div>
        {publicUrl(payload.link_url) && (
          <a
            className="text-sm text-primary break-all"
            href={payload.link_url}
            target="_blank"
            rel="noopener noreferrer"
          >
            打开落地页 ↗
          </a>
        )}
      </div>
      <div className="rounded-md bg-gray-50 p-3 text-sm space-y-1">
        <p>渠道标记：{payload.attribution_enabled ? "已开启（传递本广告固定渠道编号）" : "未开启"}</p>
        <p className="break-all">渠道参数名：{payload.click_id_param ?? "channel_id"}{!payload.attribution_enabled && "（未启用）"}</p>
      </div>
      <div className="grid gap-4 lg:grid-cols-2">
        {payload.placements.map((p) => (
          <div
            key={p.placement}
            className="rounded-lg border border-gray-200 overflow-hidden"
          >
            <div className="px-3 py-2 bg-gray-50 text-xs text-gray-500 flex justify-between">
              <span>{PLACEMENTS[p.placement]}</span>
              <span>排序 {p.sort_order}</span>
            </div>
            <div className="p-3 space-y-2">
              {p.image_url && creativeUrl(p.image_url) ? (
                <img
                  src={p.image_url}
                  alt={PLACEMENTS[p.placement]}
                  className={`w-full object-contain rounded bg-gray-50 ${p.placement === "home_carousel" ? "h-44" : "h-24"}`}
                />
              ) : (
                <div className="h-16 rounded bg-sky-50 flex items-center justify-center text-sm text-sky-700">
                  请上传广告图片
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      <p className="text-xs text-gray-400 break-all">
        落地页：{payload.link_url || "未填写"}
      </p>
    </div>
  );
}
